import { cohttp } from '../../../httpsnippet-lite/targets/ocaml/cohttp/client.js';
import { convertWithHttpSnippetLite } from '../../../utils/convertWithHttpSnippetLite.js';
/**
 * ocaml/cohttp
 */
export const ocamlCohttp = {
    target: 'ocaml',
    client: 'cohttp',
    title: 'Cohttp',
    generate(request) {
        // TODO: Write an own converter
        return convertWithHttpSnippetLite(cohttp, request);
    },
};
